import { createReducer } from '@reduxjs/toolkit'
import { receiveNoTourAccountData, clear, logout } from 'model/actions'
import { NoTourAccountDataT } from 'types/model'

const initialState = null as NoTourAccountDataT | null

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveNoTourAccountData, (_state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
